import en from 'src/i18n/locales/en'
import es from 'src/i18n/locales/es'

export default {
  en,
  es
}
